module.exports = __webpack_public_path__ + "img/banner_v2.31da5180.png";